export default __webpack_public_path__ + "static/media/wine_bar1.8aeae314.jpg";